// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { LoginData, LoginResponse2, GetUsersData, GetUsersResponse, CreateUserData, CreateUserResponse, UpdateUserData, UpdateUserResponse, DeleteUserData, DeleteUserResponse, GetUserResponse, GetRolesData, GetRolesResponse2, CreateRoleData, CreateRoleResponse, GetRoleData, GetRoleResponse2, UpdateRoleData, UpdateRoleResponse, DeleteRoleData, DeleteRoleResponse, ResetPasswordData, ResetPasswordResponse, GetProductVariantTypesData, GetProductVariantTypesResponse, CreateProductVariantTypeData, CreateProductVariantTypeResponse, GetProductVariantTypeData, GetProductVariantTypeResponse, UpdateProductVariantTypeData, UpdateProductVariantTypeResponse, DeleteProductVariantTypeData, DeleteProductVariantTypeResponse, GetProductVariantValuesData, GetProductVariantValuesResponse, CreateProductVariantValueData, CreateProductVariantValueResponse, GetProductVariantValueData, GetProductVariantValueResponse, UpdateProductVariantValueData, UpdateProductVariantValueResponse, DeleteProductVariantValueData, DeleteProductVariantValueResponse, BackupDatabaseControllerResponse, RestoreDatabaseData, RestoreDatabaseResponse, GetCompanyDetailsResponse, UpdateCompanyDetailsData, UpdateCompanyDetailsResponse, ListPaymentMethodsData, ListPaymentMethodsResponse, CreatePaymentMethodData, CreatePaymentMethodResponse, GetPaymentMethodData, GetPaymentMethodResponse, UpdatePaymentMethodData, UpdatePaymentMethodResponse, DeletePaymentMethodData, DeletePaymentMethodResponse, GetAllVendorsData, GetAllVendorsResponse, CreateVendorData, CreateVendorResponse, GetVendorByIdData, GetVendorByIdResponse, UpdateVendorData, UpdateVendorResponse, DeleteVendorData, DeleteVendorResponse, GetVendorPurchasesData, GetVendorPurchasesResponse, GetVendorStatementOfAccountData, GetVendorStatementOfAccountResponse, GetServiceCategoryData, GetServiceCategoryResponse2, CreateServiceCategoryData, CreateServiceCategoryResponse, UpdateServiceData, UpdateServiceResponse, DeleteServiceData, DeleteServiceResponse, GetServicesData, GetServicesResponse2, CreateServiceData, CreateServiceResponse, GetLocationsData, GetLocationsResponse, CreateLocationData, CreateLocationResponse, UpdateLocationData, UpdateLocationResponse, DeleteLocationData, DeleteLocationResponse, GetBrandsData, GetBrandsResponse, CreateBrandData, CreateBrandResponse, UpdateBrandData, UpdateBrandResponse, DeleteBrandData, DeleteBrandResponse, GetProductCategoriesData, GetProductCategoriesResponse, CreateProductCategoryData, CreateProductCategoryResponse, GetProductSubcategoryData, GetProductSubcategoryResponse, GetProductParentCategoryData, GetProductParentCategoryResponse, GetProductCategoryOptionItemsData, GetProductCategoryOptionItemsResponse, UpdateProductCategoryData, UpdateProductCategoryResponse, DeleteProductCategoryData, DeleteProductCategoryResponse, GetProductsData, GetProductsResponse, CreateProductData, CreateProductResponse, DownloadProductListResponse, GetTotalProductsResponse, GetAllProductsData, GetAllProductsResponse, GetShopProductsData, GetShopProductsResponse, GetLocationProductQuantityData, GetLocationProductQuantityResponse, QuickUpdateProductData, QuickUpdateProductResponse, UpdateProductData, UpdateProductResponse, GetProductData, GetProductResponse, DeleteProductData, DeleteProductResponse, CreateProductVariantData, CreateProductVariantResponse, UpdateProductVariantData, UpdateProductVariantResponse, DeleteProductVariantData, DeleteProductVariantResponse, GetPurchaseOrdersData, GetPurchaseOrdersResponse, CreatePurchaseOrderData, CreatePurchaseOrderResponse, UpdatePurchaseOrderData, UpdatePurchaseOrderResponse, DeletePurchaseOrderData, DeletePurchaseOrderResponse, GetPurchaseOrderData, GetPurchaseOrderResponse, ApprovePurchaseOrderData, ApprovePurchaseOrderResponse, RecordPurchaseOrderPaymentData, RecordPurchaseOrderPaymentResponse, UpdatePurchaseDeliveryStatusData, UpdatePurchaseDeliveryStatusResponse, CreateDeliveryNoteData, CreateDeliveryNoteResponse, GetPurchaseOrderPaymentsData, GetPurchaseOrderPaymentsResponse, GetInventoryTransactionsData, GetInventoryTransactionsResponse, CreateInventoryTransactionData, CreateInventoryTransactionResponse, QuickAdjustmentData, QuickAdjustmentResponse, GetModelsData, GetModelsResponse, GetModelCategoriesData, GetModelCategoriesResponse, CreateModelData, CreateModelResponse, UpdateModelData, UpdateModelResponse, DeleteModelData, DeleteModelResponse, CreateModelCategoryData, CreateModelCategoryResponse, UpdateModelCategoryData, UpdateModelCategoryResponse, GetInventoryStockData, GetInventoryStockResponse, DownloadInventoryStockReportResponse, GetBarcodesData, GetBarcodesResponse, RecordPrintedBarcodesData, RecordPrintedBarcodesResponse, GetInvoicesData, GetInvoicesResponse, CreateInvoiceData, CreateInvoiceResponse, GetInvoiceDetailsData, GetInvoiceDetailsResponse, CreateInvoicePaymentData, CreateInvoicePaymentResponse, CancelInvoiceData, CancelInvoiceResponse, GetInventoryStockReportData, GetInventoryStockReportResponse, GetDashboardOverviewData, GetDashboardOverviewResponse, GetAssistantPromptData, GetAssistantPromptResponse, DownloadInventoryAgingReportData, DownloadInventoryAgingReportResponse, DownloadInventoryValuationReportData, DownloadInventoryValuationReportResponse, DownloadInventoryMovementReportData, DownloadInventoryMovementReportResponse, DownloadInventoryLowStockAlertReportResponse, DownloadVendorSummaryReportData, DownloadVendorSummaryReportResponse, DownloadPurchaseOrdersReportData, DownloadPurchaseOrdersReportResponse, DownloadCustomerReportData, DownloadCustomerReportResponse, DownloadSalesSummaryData, DownloadSalesSummaryResponse, GetSalesSummaryData, GetSalesSummaryResponse, GetProductSalesSummaryData, GetProductSalesSummaryResponse, DownloadProductSalesSummaryData, DownloadProductSalesSummaryResponse, GetCustomerSalesSummaryData, GetCustomerSalesSummaryResponse, DownloadCustomerSalesSummaryData, DownloadCustomerSalesSummaryResponse, GetEmployeeInvoiceSummaryData, GetEmployeeInvoiceSummaryResponse, DownloadEmployeeInvoiceSummaryData, DownloadEmployeeInvoiceSummaryResponse, GetInvoiceAgingReportData, GetInvoiceAgingReportResponse, DownloadInvoiceAgingReportData, DownloadInvoiceAgingReportResponse, GetWarehouseStockReportData, GetWarehouseStockReportResponse, DownloadWarehouseStockReportData, DownloadWarehouseStockReportResponse, GetInventoryTransactionsReportData, GetInventoryTransactionsReportResponse, DownloadInventoryTransactionsReportData, DownloadInventoryTransactionsReportResponse, GetLowStockAlertReportV2Data, GetLowStockAlertReportV2Response, DownloadLowStockAlertReportV2Data, DownloadLowStockAlertReportV2Response, GetOutOfStockReportV2Data, GetOutOfStockReportV2Response, DownloadOutOfStockReportV2Data, DownloadOutOfStockReportV2Response, GetStockValuationReportV2Data, GetStockValuationReportV2Response, DownloadStockValuationReportV2Data, DownloadStockValuationReportV2Response, GetStockMovementReportData, GetStockMovementReportResponse, DownloadStockMovementReportData, DownloadStockMovementReportResponse, GetPurchaseOrderReportData, GetPurchaseOrderReportResponse, DownloadPurchaseOrderReportData, DownloadPurchaseOrderReportResponse, GetNotDeliveredPurchaseOrderReportData, GetNotDeliveredPurchaseOrderReportResponse, DownloadNotDeliveredPurchaseOrderReportData, DownloadNotDeliveredPurchaseOrderReportResponse, GetPurchaseReportData, GetPurchaseReportResponse, DownloadPurchaseReportData, DownloadPurchaseReportResponse, GetProfitLossStatementData, GetProfitLossStatementResponse, DownloadProfitLossStatementData, DownloadProfitLossStatementResponse, GetAccountingTransactionsReportData, GetAccountingTransactionsReportResponse, DownloadAccountingTransactionsReportData, DownloadAccountingTransactionsReportResponse, GetExpensesReportData, GetExpensesReportResponse, DownloadExpensesReportData, DownloadExpensesReportResponse, GetAuditLog2ReportData, GetAuditLog2ReportResponse, DownloadAuditLog2ReportData, DownloadAuditLog2ReportResponse, GetRevenueByUserReportData, GetRevenueByUserReportResponse, DownloadRevenueByUserReportData, DownloadRevenueByUserReportResponse, GetCustomerReportV2Data, GetCustomerReportV2Response, DownloadCustomerReportV2Data, DownloadCustomerReportV2Response, GetBalanceSheetV2Data, GetBalanceSheetV2Response, DownloadBalanceSheetV2Data, DownloadBalanceSheetV2Response, GetReparationReportV2Data, GetReparationReportV2Response, DownloadReparationReportV2Data, DownloadReparationReportV2Response, GetSalesReportV2Data, GetSalesReportV2Response, DownloadSalesReportV2Data, DownloadSalesReportV2Response, GetProfitReportV2Data, GetProfitReportV2Response, DownloadProfitReportV2Data, DownloadProfitReportV2Response, GetChecklistItemsResponse, CreateReparationCaseData, CreateReparationCaseResponse, GetReparationCasesData, GetReparationCasesResponse, GetReparationCaseData, GetReparationCaseResponse, UpdateReparationCaseData, UpdateReparationCaseResponse, CreateOrUpdateReviewData, CreateOrUpdateReviewResponse, CreateReparationCaseItemData, CreateReparationCaseItemResponse, UpdateReparationCaseItemData, UpdateReparationCaseItemResponse, DeleteReparationCaseItemData, DeleteReparationCaseItemResponse, CreateInvoiceFromReparationCaseData, CreateInvoiceFromReparationCaseResponse, CreateRcPaymentData, CreateRcPaymentResponse, UpdateCaseStatusData, UpdateCaseStatusResponse, GetCustomersData, GetCustomersResponse, CreateCustomerData, CreateCustomerResponse, UpdateCustomerData, UpdateCustomerResponse, DeleteCustomerData, DeleteCustomerResponse, GetCustomerData, GetCustomerResponse, GetAccountsData, GetAccountsResponse, GetChartOfAccountsData, GetChartOfAccountsResponse, GetPaymentAccountsData, GetPaymentAccountsResponse, GetExpenseAccountsData, GetExpenseAccountsResponse, GetTransactionsData, GetTransactionsResponse, CreateTransactionData, CreateTransactionResponse, UpdateTransactionData, UpdateTransactionResponse, DeleteTransactionData, DeleteTransactionResponse, GetExpenseCategoriesData, GetExpenseCategoriesResponse, CreateExpenseCategoryData, CreateExpenseCategoryResponse, GetExpensesData, GetExpensesResponse, CreateExpenseData, CreateExpenseResponse, UpdateExpenseData, UpdateExpenseResponse, DeleteExpenseData, DeleteExpenseResponse, UpdateExpenseCategoryData, UpdateExpenseCategoryResponse, DeleteExpenseCategoryData, DeleteExpenseCategoryResponse, GetTaxesData, GetTaxesResponse, CreateTaxData, CreateTaxResponse, UpdateTaxData, UpdateTaxResponse, DeleteTaxData, DeleteTaxResponse, GetCurrenciesData, GetCurrenciesResponse, CreateCurrencyData, CreateCurrencyResponse, UpdateCurrencyData, UpdateCurrencyResponse, GetBankAccountsData, GetBankAccountsResponse, CreateBankAccountData, CreateBankAccountResponse, GetBankAccountData, GetBankAccountResponse, UpdateBankAccountData, UpdateBankAccountResponse, DeleteBankAccountData, DeleteBankAccountResponse, CreateAccountData, CreateAccountResponse, UpdateAccountData, UpdateAccountResponse, DeleteAccountData, DeleteAccountResponse } from './types.gen';

export class AuthService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns LoginResponse Ok
     * @throws ApiError
     */
    public static login(data: LoginData): CancelablePromise<LoginResponse2> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/login',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Invalid username or password'
            }
        });
    }
    
}

export class UsersService {
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetUsersResponse Ok
     * @throws ApiError
     */
    public static getUsers(data: GetUsersData): CancelablePromise<GetUsersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createUser(data: CreateUserData): CancelablePromise<CreateUserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.userId
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateUser(data: UpdateUserData): CancelablePromise<UpdateUserResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/{userId}',
            path: {
                userId: data.userId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.userId
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteUser(data: DeleteUserData): CancelablePromise<DeleteUserResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/user/{userId}',
            path: {
                userId: data.userId
            }
        });
    }
    
    /**
     * @returns IGetUserResponse Ok
     * @throws ApiError
     */
    public static getUser(): CancelablePromise<GetUserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/me'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns GetRolesResponse Ok
     * @throws ApiError
     */
    public static getRoles(data: GetRolesData): CancelablePromise<GetRolesResponse2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/roles',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createRole(data: CreateRoleData): CancelablePromise<CreateRoleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/roles',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.roleId
     * @returns GetRoleResponse Ok
     * @throws ApiError
     */
    public static getRole(data: GetRoleData): CancelablePromise<GetRoleResponse2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/roles/{roleId}',
            path: {
                roleId: data.roleId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.roleId
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateRole(data: UpdateRoleData): CancelablePromise<UpdateRoleResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/roles/{roleId}',
            path: {
                roleId: data.roleId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.roleId
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteRole(data: DeleteRoleData): CancelablePromise<DeleteRoleResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/user/roles/{roleId}',
            path: {
                roleId: data.roleId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.userId
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static resetPassword(data: ResetPasswordData): CancelablePromise<ResetPasswordResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/reset-password/{userId}',
            path: {
                userId: data.userId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class SettingsService {
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetProductVariantTypesResponse Ok
     * @throws ApiError
     */
    public static getProductVariantTypes(data: GetProductVariantTypesData): CancelablePromise<GetProductVariantTypesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/settings/product-variant-types',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createProductVariantType(data: CreateProductVariantTypeData): CancelablePromise<CreateProductVariantTypeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/settings/product-variant-types',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns unknown Ok
     * @throws ApiError
     */
    public static getProductVariantType(data: GetProductVariantTypeData): CancelablePromise<GetProductVariantTypeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/settings/product-variant-types/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idProductVariantType
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateProductVariantType(data: UpdateProductVariantTypeData): CancelablePromise<UpdateProductVariantTypeResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/settings/product-variant-types/{idProductVariantType}',
            path: {
                idProductVariantType: data.idProductVariantType
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idProductVariantType
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteProductVariantType(data: DeleteProductVariantTypeData): CancelablePromise<DeleteProductVariantTypeResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/settings/product-variant-types/{idProductVariantType}',
            path: {
                idProductVariantType: data.idProductVariantType
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetProductVariantValuesResponse Ok
     * @throws ApiError
     */
    public static getProductVariantValues(data: GetProductVariantValuesData): CancelablePromise<GetProductVariantValuesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/settings/product-variant-values',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createProductVariantValue(data: CreateProductVariantValueData): CancelablePromise<CreateProductVariantValueResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/settings/product-variant-values',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns unknown Ok
     * @throws ApiError
     */
    public static getProductVariantValue(data: GetProductVariantValueData): CancelablePromise<GetProductVariantValueResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/settings/product-variant-values/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idProductVariantValue
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateProductVariantValue(data: UpdateProductVariantValueData): CancelablePromise<UpdateProductVariantValueResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/settings/product-variant-values/{idProductVariantValue}',
            path: {
                idProductVariantValue: data.idProductVariantValue
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idProductVariantValue
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteProductVariantValue(data: DeleteProductVariantValueData): CancelablePromise<DeleteProductVariantValueResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/settings/product-variant-values/{idProductVariantValue}',
            path: {
                idProductVariantValue: data.idProductVariantValue
            }
        });
    }
    
    /**
     * @returns boolean Ok
     * @throws ApiError
     */
    public static backupDatabaseController(): CancelablePromise<BackupDatabaseControllerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/settings/backup'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.formData
     * @returns unknown Ok
     * @throws ApiError
     */
    public static restoreDatabase(data: RestoreDatabaseData): CancelablePromise<RestoreDatabaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/settings/restore',
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * @returns unknown Ok
     * @throws ApiError
     */
    public static getCompanyDetails(): CancelablePromise<GetCompanyDetailsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/settings/company-details'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateCompanyDetails(data: UpdateCompanyDetailsData): CancelablePromise<UpdateCompanyDetailsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/settings/company-details',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IListPaymentMethodsResponse Ok
     * @throws ApiError
     */
    public static listPaymentMethods(data: ListPaymentMethodsData): CancelablePromise<ListPaymentMethodsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/settings/payment-methods',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createPaymentMethod(data: CreatePaymentMethodData): CancelablePromise<CreatePaymentMethodResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/settings/payment-methods',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idPaymentMethod
     * @returns unknown Ok
     * @throws ApiError
     */
    public static getPaymentMethod(data: GetPaymentMethodData): CancelablePromise<GetPaymentMethodResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/settings/payment-methods/{idPaymentMethod}',
            path: {
                idPaymentMethod: data.idPaymentMethod
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idPaymentMethod
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updatePaymentMethod(data: UpdatePaymentMethodData): CancelablePromise<UpdatePaymentMethodResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/settings/payment-methods/{idPaymentMethod}',
            path: {
                idPaymentMethod: data.idPaymentMethod
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idPaymentMethod
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deletePaymentMethod(data: DeletePaymentMethodData): CancelablePromise<DeletePaymentMethodResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/settings/payment-methods/{idPaymentMethod}',
            path: {
                idPaymentMethod: data.idPaymentMethod
            }
        });
    }
    
}

export class VendorService {
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns VendorListResponse Ok
     * @throws ApiError
     */
    public static getAllVendors(data: GetAllVendorsData): CancelablePromise<GetAllVendorsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vendor',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createVendor(data: CreateVendorData): CancelablePromise<CreateVendorResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vendor',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class VendorsService {
    /**
     * @param data The data for the request.
     * @param data.vendorId
     * @returns IVendor Ok
     * @throws ApiError
     */
    public static getVendorById(data: GetVendorByIdData): CancelablePromise<GetVendorByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vendor/{vendorId}',
            path: {
                vendorId: data.vendorId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.vendorId
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateVendor(data: UpdateVendorData): CancelablePromise<UpdateVendorResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/vendor/{vendorId}',
            path: {
                vendorId: data.vendorId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.vendorId
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteVendor(data: DeleteVendorData): CancelablePromise<DeleteVendorResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/vendor/{vendorId}',
            path: {
                vendorId: data.vendorId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.vendorId
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetPurchaseOrderResponse Ok
     * @throws ApiError
     */
    public static getVendorPurchases(data: GetVendorPurchasesData): CancelablePromise<GetVendorPurchasesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vendor/{vendorId}/purchases',
            path: {
                vendorId: data.vendorId
            },
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.vendorId
     * @param data.endDate
     * @param data.startDate
     * @returns IVendorStatementOfAccountItem Ok
     * @throws ApiError
     */
    public static getVendorStatementOfAccount(data: GetVendorStatementOfAccountData): CancelablePromise<GetVendorStatementOfAccountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vendor/{vendorId}/statement-of-account',
            path: {
                vendorId: data.vendorId
            },
            query: {
                endDate: data.endDate,
                startDate: data.startDate
            }
        });
    }
    
}

export class InventoryService {
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.pagination
     * @param data.sort
     * @returns GetServiceCategoryResponse Ok
     * @throws ApiError
     */
    public static getServiceCategory(data: GetServiceCategoryData): CancelablePromise<GetServiceCategoryResponse2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/service-category',
            query: {
                filters: data.filters,
                pagination: data.pagination,
                sort: data.sort
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createServiceCategory(data: CreateServiceCategoryData): CancelablePromise<CreateServiceCategoryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/service-category',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idService
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateService(data: UpdateServiceData): CancelablePromise<UpdateServiceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/inventory/service/{idService}',
            path: {
                idService: data.idService
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idService
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteService(data: DeleteServiceData): CancelablePromise<DeleteServiceResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/inventory/service/{idService}',
            path: {
                idService: data.idService
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.pagination
     * @param data.sort
     * @returns GetServicesResponse Ok
     * @throws ApiError
     */
    public static getServices(data: GetServicesData): CancelablePromise<GetServicesResponse2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/service',
            query: {
                filters: data.filters,
                pagination: data.pagination,
                sort: data.sort
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createService(data: CreateServiceData): CancelablePromise<CreateServiceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/service',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns GetLocationResponse Ok
     * @throws ApiError
     */
    public static getLocations(data: GetLocationsData): CancelablePromise<GetLocationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/location',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createLocation(data: CreateLocationData): CancelablePromise<CreateLocationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/location',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idLocation
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateLocation(data: UpdateLocationData): CancelablePromise<UpdateLocationResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/inventory/location/{idLocation}',
            path: {
                idLocation: data.idLocation
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idLocation
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteLocation(data: DeleteLocationData): CancelablePromise<DeleteLocationResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/inventory/location/{idLocation}',
            path: {
                idLocation: data.idLocation
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetBrandsResponse Ok
     * @throws ApiError
     */
    public static getBrands(data: GetBrandsData): CancelablePromise<GetBrandsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/brand',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createBrand(data: CreateBrandData): CancelablePromise<CreateBrandResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/brand',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idBrand
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateBrand(data: UpdateBrandData): CancelablePromise<UpdateBrandResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/inventory/brand/{idBrand}',
            path: {
                idBrand: data.idBrand
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idBrand
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteBrand(data: DeleteBrandData): CancelablePromise<DeleteBrandResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/inventory/brand/{idBrand}',
            path: {
                idBrand: data.idBrand
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetProductCategoryResponse Ok
     * @throws ApiError
     */
    public static getProductCategories(data: GetProductCategoriesData): CancelablePromise<GetProductCategoriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/product-category',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createProductCategory(data: CreateProductCategoryData): CancelablePromise<CreateProductCategoryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/product-category',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetProductCategoryResponse Ok
     * @throws ApiError
     */
    public static getProductSubcategory(data: GetProductSubcategoryData): CancelablePromise<GetProductSubcategoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/product-subcategory',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetProductCategoryResponse Ok
     * @throws ApiError
     */
    public static getProductParentCategory(data: GetProductParentCategoryData): CancelablePromise<GetProductParentCategoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/product-parent-category',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetProductCategoryOptionItemsResponse Ok
     * @throws ApiError
     */
    public static getProductCategoryOptionItems(data: GetProductCategoryOptionItemsData): CancelablePromise<GetProductCategoryOptionItemsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/product-category/option-items',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idProductCategory
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateProductCategory(data: UpdateProductCategoryData): CancelablePromise<UpdateProductCategoryResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/inventory/product-category/{idProductCategory}',
            path: {
                idProductCategory: data.idProductCategory
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idProductCategory
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteProductCategory(data: DeleteProductCategoryData): CancelablePromise<DeleteProductCategoryResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/inventory/product-category/{idProductCategory}',
            path: {
                idProductCategory: data.idProductCategory
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetProductResponse Ok
     * @throws ApiError
     */
    public static getProducts(data: GetProductsData): CancelablePromise<GetProductsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/product',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            },
            errors: {
                404: 'Product not found',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createProduct(data: CreateProductData): CancelablePromise<CreateProductResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/product',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @returns unknown Ok
     * @throws ApiError
     */
    public static downloadProductList(): CancelablePromise<DownloadProductListResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/product/download'
        });
    }
    
    /**
     * @returns number Ok
     * @throws ApiError
     */
    public static getTotalProducts(): CancelablePromise<GetTotalProductsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/product/total',
            errors: {
                404: 'Product not found',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetProductResponse Ok
     * @throws ApiError
     */
    public static getAllProducts(data: GetAllProductsData): CancelablePromise<GetAllProductsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/product/all',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            },
            errors: {
                404: 'Product not found',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.limit
     * @param data.search
     * @param data.filters
     * @returns unknown Ok
     * @throws ApiError
     */
    public static getShopProducts(data: GetShopProductsData): CancelablePromise<GetShopProductsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/product/shop-search',
            query: {
                limit: data.limit,
                search: data.search,
                filters: data.filters
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns unknown Ok
     * @throws ApiError
     */
    public static getLocationProductQuantity(data: GetLocationProductQuantityData): CancelablePromise<GetLocationProductQuantityResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/product/location-quantity/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idProduct
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static quickUpdateProduct(data: QuickUpdateProductData): CancelablePromise<QuickUpdateProductResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/inventory/product/{idProduct}/quick-update',
            path: {
                idProduct: data.idProduct
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateProduct(data: UpdateProductData): CancelablePromise<UpdateProductResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/inventory/product/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns IProductDetails Ok
     * @throws ApiError
     */
    public static getProduct(data: GetProductData): CancelablePromise<GetProductResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/product/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Not found'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idProduct
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteProduct(data: DeleteProductData): CancelablePromise<DeleteProductResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/inventory/product/{idProduct}',
            path: {
                idProduct: data.idProduct
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetAllProductVariantTypesResponse Ok
     * @throws ApiError
     */
    public static getProductVariantTypes(data: GetProductVariantTypesData): CancelablePromise<GetProductVariantTypesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/product-variant/types',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createProductVariant(data: CreateProductVariantData): CancelablePromise<CreateProductVariantResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/product/{id}/variant',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateProductVariant(data: UpdateProductVariantData): CancelablePromise<UpdateProductVariantResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/inventory/product/{id}/variant',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.idVariant
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteProductVariant(data: DeleteProductVariantData): CancelablePromise<DeleteProductVariantResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/inventory/product/{id}/variant/{idVariant}',
            path: {
                id: data.id,
                idVariant: data.idVariant
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetPurchaseOrderResponse Ok
     * @throws ApiError
     */
    public static getPurchaseOrders(data: GetPurchaseOrdersData): CancelablePromise<GetPurchaseOrdersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/purchase-order',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Created
     * @throws ApiError
     */
    public static createPurchaseOrder(data: CreatePurchaseOrderData): CancelablePromise<CreatePurchaseOrderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/purchase-order',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.purchaseOrderId
     * @param data.requestBody
     * @returns unknown Updated
     * @throws ApiError
     */
    public static updatePurchaseOrder(data: UpdatePurchaseOrderData): CancelablePromise<UpdatePurchaseOrderResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/inventory/purchase-order/{purchaseOrderId}',
            path: {
                purchaseOrderId: data.purchaseOrderId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.purchaseOrderId
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deletePurchaseOrder(data: DeletePurchaseOrderData): CancelablePromise<DeletePurchaseOrderResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/inventory/purchase-order/{purchaseOrderId}',
            path: {
                purchaseOrderId: data.purchaseOrderId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns IGetPurchaseOrderDetailsResponse Ok
     * @throws ApiError
     */
    public static getPurchaseOrder(data: GetPurchaseOrderData): CancelablePromise<GetPurchaseOrderResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/purchase-order/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.purchaseOrderId
     * @returns unknown Ok
     * @throws ApiError
     */
    public static approvePurchaseOrder(data: ApprovePurchaseOrderData): CancelablePromise<ApprovePurchaseOrderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/purchase-order/{purchaseOrderId}/approve',
            path: {
                purchaseOrderId: data.purchaseOrderId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.purchaseOrderId
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static recordPurchaseOrderPayment(data: RecordPurchaseOrderPaymentData): CancelablePromise<RecordPurchaseOrderPaymentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/purchase-order/{purchaseOrderId}/payment',
            path: {
                purchaseOrderId: data.purchaseOrderId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.purchaseOrderId
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updatePurchaseDeliveryStatus(data: UpdatePurchaseDeliveryStatusData): CancelablePromise<UpdatePurchaseDeliveryStatusResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/purchase-order/{purchaseOrderId}/delivery-status',
            path: {
                purchaseOrderId: data.purchaseOrderId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.purchaseOrderId
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createDeliveryNote(data: CreateDeliveryNoteData): CancelablePromise<CreateDeliveryNoteResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/purchase-order/{purchaseOrderId}/delivery-note',
            path: {
                purchaseOrderId: data.purchaseOrderId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.purchaseOrderId
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetPurchaseOrderPaymentsResponse Ok
     * @throws ApiError
     */
    public static getPurchaseOrderPayments(data: GetPurchaseOrderPaymentsData): CancelablePromise<GetPurchaseOrderPaymentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/purchase-order/{purchaseOrderId}/payments',
            path: {
                purchaseOrderId: data.purchaseOrderId
            },
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetInventoryTransactionsResponse Ok
     * @throws ApiError
     */
    public static getInventoryTransactions(data: GetInventoryTransactionsData): CancelablePromise<GetInventoryTransactionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/inventory-transactions',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createInventoryTransaction(data: CreateInventoryTransactionData): CancelablePromise<CreateInventoryTransactionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/transaction',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Inventory adjusted successfully
     * @throws ApiError
     */
    public static quickAdjustment(data: QuickAdjustmentData): CancelablePromise<QuickAdjustmentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/quick-adjustment',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetModelsResponse Ok
     * @throws ApiError
     */
    public static getModels(data: GetModelsData): CancelablePromise<GetModelsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/product/models',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetModelCategoriesResponse Ok
     * @throws ApiError
     */
    public static getModelCategories(data: GetModelCategoriesData): CancelablePromise<GetModelCategoriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/product/model-categories',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createModel(data: CreateModelData): CancelablePromise<CreateModelResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/product/model',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idModel
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateModel(data: UpdateModelData): CancelablePromise<UpdateModelResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/inventory/product/model/{idModel}',
            path: {
                idModel: data.idModel
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idModel
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteModel(data: DeleteModelData): CancelablePromise<DeleteModelResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/inventory/product/model/{idModel}',
            path: {
                idModel: data.idModel
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createModelCategory(data: CreateModelCategoryData): CancelablePromise<CreateModelCategoryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/product/model-category',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idModelCategory
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateModelCategory(data: UpdateModelCategoryData): CancelablePromise<UpdateModelCategoryResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/inventory/product/model-category/{idModelCategory}',
            path: {
                idModelCategory: data.idModelCategory
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetInventoryStockResponse Ok
     * @throws ApiError
     */
    public static getInventoryStock(data: GetInventoryStockData): CancelablePromise<GetInventoryStockResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/stock',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @returns unknown Ok
     * @throws ApiError
     */
    public static downloadInventoryStockReport(): CancelablePromise<DownloadInventoryStockReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/stock/download'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.pagination
     * @param data.sort
     * @param data.order
     * @param data.filters
     * @param data.searchQuery
     * @returns unknown Ok
     * @throws ApiError
     */
    public static getBarcodes(data: GetBarcodesData = {}): CancelablePromise<GetBarcodesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/inventory/barcodes',
            query: {
                pagination: data.pagination,
                sort: data.sort,
                order: data.order,
                filters: data.filters,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static recordPrintedBarcodes(data: RecordPrintedBarcodesData): CancelablePromise<RecordPrintedBarcodesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/inventory/barcodes/printed/record',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class SalesService {
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns IGetInvoicesResponse Ok
     * @throws ApiError
     */
    public static getInvoices(data: GetInvoicesData): CancelablePromise<GetInvoicesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/sales/invoice',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns SuccessResponse Ok
     * @throws ApiError
     */
    public static createInvoice(data: CreateInvoiceData): CancelablePromise<CreateInvoiceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/sales/invoice',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idInvoice
     * @returns IGetInvoiceDetailsResponse Ok
     * @throws ApiError
     */
    public static getInvoiceDetails(data: GetInvoiceDetailsData): CancelablePromise<GetInvoiceDetailsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/sales/invoice/{idInvoice}',
            path: {
                idInvoice: data.idInvoice
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idInvoice
     * @param data.requestBody
     * @returns SuccessResponse Ok
     * @throws ApiError
     */
    public static createInvoicePayment(data: CreateInvoicePaymentData): CancelablePromise<CreateInvoicePaymentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/sales/invoice/{idInvoice}/payment',
            path: {
                idInvoice: data.idInvoice
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idInvoice
     * @returns SuccessResponse Ok
     * @throws ApiError
     */
    public static cancelInvoice(data: CancelInvoiceData): CancelablePromise<CancelInvoiceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/sales/invoice/{idInvoice}/cancel',
            path: {
                idInvoice: data.idInvoice
            }
        });
    }
    
}

export class InventoryReportsService {
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @returns IInventoryStockReportResponse Ok
     * @throws ApiError
     */
    public static getInventoryStockReport(data: GetInventoryStockReportData = {}): CancelablePromise<GetInventoryStockReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/inventory-stock-report',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.range
     * @returns IDashboardOverviewResponse Ok
     * @throws ApiError
     */
    public static getDashboardOverview(data: GetDashboardOverviewData): CancelablePromise<GetDashboardOverviewResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/dashboard/overview',
            query: {
                range: data.range
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns string Assistant prompt generated successfully
     * @throws ApiError
     */
    public static getAssistantPrompt(data: GetAssistantPromptData): CancelablePromise<GetAssistantPromptResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/dashboard/assistant-prompt',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns GetDownloadResponse Inventory aging report downloaded successfully
     * @throws ApiError
     */
    public static downloadInventoryAgingReport(data: DownloadInventoryAgingReportData): CancelablePromise<DownloadInventoryAgingReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/inventory/aging-report/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns GetDownloadResponse Inventory valuation report downloaded successfully
     * @throws ApiError
     */
    public static downloadInventoryValuationReport(data: DownloadInventoryValuationReportData): CancelablePromise<DownloadInventoryValuationReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/inventory/valuation-report/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns GetDownloadResponse Inventory movement report downloaded successfully
     * @throws ApiError
     */
    public static downloadInventoryMovementReport(data: DownloadInventoryMovementReportData): CancelablePromise<DownloadInventoryMovementReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/inventory/movement-report/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @returns GetDownloadResponse Low stock alert report downloaded successfully
     * @throws ApiError
     */
    public static downloadInventoryLowStockAlertReport(): CancelablePromise<DownloadInventoryLowStockAlertReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/inventory/low-stock-alert-report/download'
        });
    }
    
    /**
     * Download Vendor Summary Report.
     * This report provides an overview of vendor purchases, including:
     * - Total number of purchase orders per vendor.
     * - Total purchase amounts per vendor.
     * - Total paid and total owed per vendor.
     * - Counts for each purchase order status.
     * @param data The data for the request.
     * @param data.startDate - The start date for the report filter (format: YYYY-MM-DD).
     * @param data.endDate - The end date for the report filter (format: YYYY-MM-DD).
     * @param data.vendorId - (Optional) Filter by vendor id.
     * @returns GetDownloadResponse Vendor summary report downloaded successfully
     * @throws ApiError
     */
    public static downloadVendorSummaryReport(data: DownloadVendorSummaryReportData): CancelablePromise<DownloadVendorSummaryReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/vendor/vendor-summary/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate,
                vendorId: data.vendorId
            }
        });
    }
    
    /**
     * Download Purchase Orders Report.
     * This report tracks vendor purchase orders, including:
     * - Expected delivery dates.
     * - Tracking numbers.
     * - Vendor details.
     * - Status of each purchase order.
     * @param data The data for the request.
     * @param data.startDate - The start date for the report filter (format: YYYY-MM-DD).
     * @param data.endDate - The end date for the report filter (format: YYYY-MM-DD).
     * @param data.vendorId - (Optional) Filter by vendor ID.
     * @param data.status - (Optional) Filter by purchase order status.
     * @returns GetDownloadResponse Purchase orders report downloaded successfully
     * @throws ApiError
     */
    public static downloadPurchaseOrdersReport(data: DownloadPurchaseOrdersReportData): CancelablePromise<DownloadPurchaseOrdersReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/vendor/purchase-orders/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate,
                vendorId: data.vendorId,
                status: data.status
            }
        });
    }
    
    /**
     * Download Customer Report.
     * This report provides an overview of customer activity, including:
     * - Total invoices issued.
     * - Total invoice amounts.
     * - Total payments received.
     * - Outstanding balance.
     * @param data The data for the request.
     * @param data.startDate - The start date for the report filter (format: YYYY-MM-DD).
     * @param data.endDate - The end date for the report filter (format: YYYY-MM-DD).
     * @param data.customerId - (Optional) Filter by customer ID.
     * @returns GetDownloadResponse Customer report downloaded successfully
     * @throws ApiError
     */
    public static downloadCustomerReport(data: DownloadCustomerReportData): CancelablePromise<DownloadCustomerReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/customer/report/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate,
                customerId: data.customerId
            }
        });
    }
    
    /**
     * Download Sales Summary Report.
     * This report provides an overview of sales performance, including:
     * - Total sales amount.
     * - Total number of invoices.
     * - Top-selling products.
     * @param data The data for the request.
     * @param data.startDate - The start date for the report filter (format: YYYY-MM-DD).
     * @param data.endDate - The end date for the report filter (format: YYYY-MM-DD).
     * @param data.groupBy
     * @returns GetDownloadResponse Sales summary report downloaded successfully
     * @throws ApiError
     */
    public static downloadSalesSummary(data: DownloadSalesSummaryData): CancelablePromise<DownloadSalesSummaryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/sales/summary/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate,
                groupBy: data.groupBy
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @param data.groupBy
     * @returns SalesSummaryResponse Sales summary retrieved successfully
     * @throws ApiError
     */
    public static getSalesSummary(data: GetSalesSummaryData): CancelablePromise<GetSalesSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/sales/summary',
            query: {
                startDate: data.startDate,
                endDate: data.endDate,
                groupBy: data.groupBy
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns ProductSalesSummaryResponse Product sales summary retrieved successfully
     * @throws ApiError
     */
    public static getProductSalesSummary(data: GetProductSalesSummaryData): CancelablePromise<GetProductSalesSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/sales/by-product',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns GetDownloadResponse Product sales summary report downloaded successfully
     * @throws ApiError
     */
    public static downloadProductSalesSummary(data: DownloadProductSalesSummaryData): CancelablePromise<DownloadProductSalesSummaryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/sales/by-product/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns CustomerSalesSummaryResponse Customer sales summary retrieved successfully
     * @throws ApiError
     */
    public static getCustomerSalesSummary(data: GetCustomerSalesSummaryData): CancelablePromise<GetCustomerSalesSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/sales/by-customer',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns GetDownloadResponse Customer sales summary report downloaded successfully
     * @throws ApiError
     */
    public static downloadCustomerSalesSummary(data: DownloadCustomerSalesSummaryData): CancelablePromise<DownloadCustomerSalesSummaryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/sales/by-customer/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns EmployeeInvoiceSummaryResponse Employee invoice summary retrieved successfully
     * @throws ApiError
     */
    public static getEmployeeInvoiceSummary(data: GetEmployeeInvoiceSummaryData): CancelablePromise<GetEmployeeInvoiceSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/sales/by-employee',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns GetDownloadResponse Employee invoice summary report downloaded successfully
     * @throws ApiError
     */
    public static downloadEmployeeInvoiceSummary(data: DownloadEmployeeInvoiceSummaryData): CancelablePromise<DownloadEmployeeInvoiceSummaryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/sales/by-employee/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns unknown Invoice aging report retrieved successfully
     * @throws ApiError
     */
    public static getInvoiceAgingReport(data: GetInvoiceAgingReportData): CancelablePromise<GetInvoiceAgingReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/sales/invoice-aging-report',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns GetDownloadResponse Invoice aging report downloaded successfully
     * @throws ApiError
     */
    public static downloadInvoiceAgingReport(data: DownloadInvoiceAgingReportData): CancelablePromise<DownloadInvoiceAgingReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/sales/invoice-aging-report/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.locationType
     * @param data.isActive
     * @param data.limit
     * @param data.offset
     * @returns IWarehouseStockReportResponse Warehouse stock report retrieved successfully
     * @throws ApiError
     */
    public static getWarehouseStockReport(data: GetWarehouseStockReportData = {}): CancelablePromise<GetWarehouseStockReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/warehouse/stock-report',
            query: {
                locationType: data.locationType,
                isActive: data.isActive,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.locationType
     * @param data.isActive
     * @returns GetDownloadResponse Warehouse stock report downloaded successfully
     * @throws ApiError
     */
    public static downloadWarehouseStockReport(data: DownloadWarehouseStockReportData = {}): CancelablePromise<DownloadWarehouseStockReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/warehouse/stock-report/download',
            query: {
                locationType: data.locationType,
                isActive: data.isActive
            }
        });
    }
    
}

export class ReportsService {
    /**
     * @param data The data for the request.
     * @param data.transactionType
     * @param data.startDate
     * @param data.endDate
     * @param data.productId
     * @param data.locationId
     * @param data.limit
     * @param data.offset
     * @returns IInventoryTransactionsReportResponse Inventory transactions report retrieved successfully
     * @throws ApiError
     */
    public static getInventoryTransactionsReport(data: GetInventoryTransactionsReportData = {}): CancelablePromise<GetInventoryTransactionsReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/inventory/transactions-report',
            query: {
                transactionType: data.transactionType,
                startDate: data.startDate,
                endDate: data.endDate,
                productId: data.productId,
                locationId: data.locationId,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.transactionType
     * @param data.startDate
     * @param data.endDate
     * @param data.productId
     * @param data.locationId
     * @returns InventoryTransactionsReportDownloadResponse Inventory transactions report downloaded successfully
     * @throws ApiError
     */
    public static downloadInventoryTransactionsReport(data: DownloadInventoryTransactionsReportData = {}): CancelablePromise<DownloadInventoryTransactionsReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/inventory/transactions-report/download',
            query: {
                transactionType: data.transactionType,
                startDate: data.startDate,
                endDate: data.endDate,
                productId: data.productId,
                locationId: data.locationId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.limit
     * @param data.offset
     * @param data.search
     * @returns ILowStockAlertReportResponse Low stock alert report retrieved successfully
     * @throws ApiError
     */
    public static getLowStockAlertReportV2(data: GetLowStockAlertReportV2Data = {}): CancelablePromise<GetLowStockAlertReportV2Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/inventory/v2/low-stock-alert-report',
            query: {
                limit: data.limit,
                offset: data.offset,
                search: data.search
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @returns LowStockAlertReportDownloadResponse Low stock alert report downloaded successfully
     * @throws ApiError
     */
    public static downloadLowStockAlertReportV2(data: DownloadLowStockAlertReportV2Data = {}): CancelablePromise<DownloadLowStockAlertReportV2Response> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/inventory/v2/low-stock-alert-report/download',
            query: {
                search: data.search
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.limit
     * @param data.offset
     * @param data.search
     * @returns ILowStockAlertReportResponse Out of stock report retrieved successfully
     * @throws ApiError
     */
    public static getOutOfStockReportV2(data: GetOutOfStockReportV2Data = {}): CancelablePromise<GetOutOfStockReportV2Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/inventory/v2/out-of-stock-report',
            query: {
                limit: data.limit,
                offset: data.offset,
                search: data.search
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @returns LowStockAlertReportDownloadResponse Out of stock report downloaded successfully
     * @throws ApiError
     */
    public static downloadOutOfStockReportV2(data: DownloadOutOfStockReportV2Data = {}): CancelablePromise<DownloadOutOfStockReportV2Response> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/inventory/v2/out-of-stock-report/download',
            query: {
                search: data.search
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.limit
     * @param data.offset
     * @param data.search
     * @returns IStockValuationReportResponse Stock valuation report retrieved successfully
     * @throws ApiError
     */
    public static getStockValuationReportV2(data: GetStockValuationReportV2Data = {}): CancelablePromise<GetStockValuationReportV2Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/inventory/v2/stock-valuation-report',
            query: {
                limit: data.limit,
                offset: data.offset,
                search: data.search
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @returns StockValuationReportDownloadResponse Stock valuation report downloaded successfully
     * @throws ApiError
     */
    public static downloadStockValuationReportV2(data: DownloadStockValuationReportV2Data = {}): CancelablePromise<DownloadStockValuationReportV2Response> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/inventory/v2/stock-valuation-report/download',
            query: {
                search: data.search
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @param data.limit
     * @param data.offset
     * @returns IStockMovementReportResponse Stock movement report retrieved successfully
     * @throws ApiError
     */
    public static getStockMovementReport(data: GetStockMovementReportData = {}): CancelablePromise<GetStockMovementReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/inventory/v2/stock-movement-report',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @returns unknown Stock movement report downloaded successfully
     * @throws ApiError
     */
    public static downloadStockMovementReport(data: DownloadStockMovementReportData = {}): CancelablePromise<DownloadStockMovementReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/inventory/v2/stock-movement-report/download',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @param data.limit
     * @param data.offset
     * @returns IPurchaseOrderReportResponse Purchase order report retrieved successfully
     * @throws ApiError
     */
    public static getPurchaseOrderReport(data: GetPurchaseOrderReportData = {}): CancelablePromise<GetPurchaseOrderReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/purchase-order-report',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @returns PurchaseOrderReportDownloadResponse Purchase order report downloaded successfully
     * @throws ApiError
     */
    public static downloadPurchaseOrderReport(data: DownloadPurchaseOrderReportData = {}): CancelablePromise<DownloadPurchaseOrderReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/purchase-order-report/download',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @param data.limit
     * @param data.offset
     * @returns IPurchaseOrderReportResponse Not delivered purchase order report retrieved successfully
     * @throws ApiError
     */
    public static getNotDeliveredPurchaseOrderReport(data: GetNotDeliveredPurchaseOrderReportData = {}): CancelablePromise<GetNotDeliveredPurchaseOrderReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/purchase-order-report/not-delivered',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @returns PurchaseOrderReportDownloadResponse Not delivered purchase order report downloaded successfully
     * @throws ApiError
     */
    public static downloadNotDeliveredPurchaseOrderReport(data: DownloadNotDeliveredPurchaseOrderReportData = {}): CancelablePromise<DownloadNotDeliveredPurchaseOrderReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/purchase-order-report/not-delivered/download',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @param data.limit
     * @param data.offset
     * @returns IPurchaseReportResponse Purchase report retrieved successfully
     * @throws ApiError
     */
    public static getPurchaseReport(data: GetPurchaseReportData = {}): CancelablePromise<GetPurchaseReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/purchase-report',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @returns PurchaseReportDownloadResponse Purchase report downloaded successfully
     * @throws ApiError
     */
    public static downloadPurchaseReport(data: DownloadPurchaseReportData = {}): CancelablePromise<DownloadPurchaseReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/purchase-report/download',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns IProfitLossStatementResponse Profit & Loss statement retrieved successfully
     * @throws ApiError
     */
    public static getProfitLossStatement(data: GetProfitLossStatementData): CancelablePromise<GetProfitLossStatementResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/profit-loss-statement',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns ProfitLossStatementDownloadResponse Profit & Loss statement downloaded successfully
     * @throws ApiError
     */
    public static downloadProfitLossStatement(data: DownloadProfitLossStatementData): CancelablePromise<DownloadProfitLossStatementResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/profit-loss-statement/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @param data.limit
     * @param data.offset
     * @returns IAccountingTransactionReportResponse Accounting transactions report retrieved successfully
     * @throws ApiError
     */
    public static getAccountingTransactionsReport(data: GetAccountingTransactionsReportData = {}): CancelablePromise<GetAccountingTransactionsReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/accounting/transactions-report',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @returns AccountingTransactionReportDownloadResponse Accounting transactions report downloaded successfully
     * @throws ApiError
     */
    public static downloadAccountingTransactionsReport(data: DownloadAccountingTransactionsReportData = {}): CancelablePromise<DownloadAccountingTransactionsReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/accounting/transactions-report/download',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @param data.limit
     * @param data.offset
     * @returns IExpenseReportResponse Expenses report retrieved successfully
     * @throws ApiError
     */
    public static getExpensesReport(data: GetExpensesReportData = {}): CancelablePromise<GetExpensesReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/expenses-report',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @returns ExpenseReportDownloadResponse Expenses report downloaded successfully
     * @throws ApiError
     */
    public static downloadExpensesReport(data: DownloadExpensesReportData = {}): CancelablePromise<DownloadExpensesReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/expenses-report/download',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @param data.limit
     * @param data.offset
     * @returns IAuditLog2ReportResponse AuditLog2 report retrieved successfully
     * @throws ApiError
     */
    public static getAuditLog2Report(data: GetAuditLog2ReportData = {}): CancelablePromise<GetAuditLog2ReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/audit-log2-report',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @returns AuditLog2ReportDownloadResponse AuditLog2 report downloaded successfully
     * @throws ApiError
     */
    public static downloadAuditLog2Report(data: DownloadAuditLog2ReportData = {}): CancelablePromise<DownloadAuditLog2ReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/audit-log2-report/download',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * Revenue by User Report (listing + KPIs)
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @param data.limit
     * @param data.offset
     * @returns IRevenueByUserReportResponse Revenue by user report retrieved successfully
     * @throws ApiError
     */
    public static getRevenueByUserReport(data: GetRevenueByUserReportData = {}): CancelablePromise<GetRevenueByUserReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/revenue-by-user-report',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * Revenue by User Report (Excel download)
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @returns RevenueByUserReportDownloadResponse Revenue by user report downloaded successfully
     * @throws ApiError
     */
    public static downloadRevenueByUserReport(data: DownloadRevenueByUserReportData = {}): CancelablePromise<DownloadRevenueByUserReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/revenue-by-user-report/download',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * Get Customer Report (list with KPIs, pagination, search, date range)
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @param data.limit
     * @param data.offset
     * @returns ICustomerReportV2Response Customer report retrieved successfully
     * @throws ApiError
     */
    public static getCustomerReportV2(data: GetCustomerReportV2Data = {}): CancelablePromise<GetCustomerReportV2Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/v2/customer-report',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * Download Customer Report (Excel)
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @returns CustomerReportDownloadV2Response Customer report downloaded successfully
     * @throws ApiError
     */
    public static downloadCustomerReportV2(data: DownloadCustomerReportV2Data = {}): CancelablePromise<DownloadCustomerReportV2Response> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/v2/customer-report/download',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * Get Balance Sheet V2 Report (within date range)
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns IBalanceSheetV2Response Balance sheet retrieved successfully
     * @throws ApiError
     */
    public static getBalanceSheetV2(data: GetBalanceSheetV2Data = {}): CancelablePromise<GetBalanceSheetV2Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/v2/balance-sheet',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * Download Balance Sheet V2 Report (Excel)
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns BalanceSheetV2DownloadResponse Balance sheet downloaded successfully
     * @throws ApiError
     */
    public static downloadBalanceSheetV2(data: DownloadBalanceSheetV2Data = {}): CancelablePromise<DownloadBalanceSheetV2Response> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/v2/balance-sheet/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @param data.limit
     * @param data.offset
     * @returns IReparationReportV2Response Reparation report retrieved successfully
     * @throws ApiError
     */
    public static getReparationReportV2(data: GetReparationReportV2Data = {}): CancelablePromise<GetReparationReportV2Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/reparation/v2/report',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.search
     * @param data.startDate
     * @param data.endDate
     * @returns ReparationReportV2DownloadResponse Reparation report downloaded successfully
     * @throws ApiError
     */
    public static downloadReparationReportV2(data: DownloadReparationReportV2Data = {}): CancelablePromise<DownloadReparationReportV2Response> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/reparation/v2/report/download',
            query: {
                search: data.search,
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @param data.totalSalesPage
     * @param data.totalSalesPageSize
     * @param data.productSalesPage
     * @param data.productSalesPageSize
     * @param data.reparationSalesPage
     * @param data.reparationSalesPageSize
     * @param data.topProductsPage
     * @param data.topProductsPageSize
     * @returns ISalesReportV2Response Sales report retrieved successfully
     * @throws ApiError
     */
    public static getSalesReportV2(data: GetSalesReportV2Data = {}): CancelablePromise<GetSalesReportV2Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/v2/sales-report',
            query: {
                startDate: data.startDate,
                endDate: data.endDate,
                totalSalesPage: data.totalSalesPage,
                totalSalesPageSize: data.totalSalesPageSize,
                productSalesPage: data.productSalesPage,
                productSalesPageSize: data.productSalesPageSize,
                reparationSalesPage: data.reparationSalesPage,
                reparationSalesPageSize: data.reparationSalesPageSize,
                topProductsPage: data.topProductsPage,
                topProductsPageSize: data.topProductsPageSize
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns SalesReportV2DownloadResponse Sales report downloaded successfully
     * @throws ApiError
     */
    public static downloadSalesReportV2(data: DownloadSalesReportV2Data = {}): CancelablePromise<DownloadSalesReportV2Response> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/v2/sales-report/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns IProfitReportV2Response Profit report retrieved successfully
     * @throws ApiError
     */
    public static getProfitReportV2(data: GetProfitReportV2Data = {}): CancelablePromise<GetProfitReportV2Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/v2/profit-report',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @returns ProfitReportV2DownloadResponse Profit report downloaded successfully
     * @throws ApiError
     */
    public static downloadProfitReportV2(data: DownloadProfitReportV2Data = {}): CancelablePromise<DownloadProfitReportV2Response> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/v2/profit-report/download',
            query: {
                startDate: data.startDate,
                endDate: data.endDate
            }
        });
    }
    
}

export class ReparationService {
    /**
     * @returns IGetChecklistItemsResponse Ok
     * @throws ApiError
     */
    public static getChecklistItems(): CancelablePromise<GetChecklistItemsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reparation/checklist-items'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.formData
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createReparationCase(data: CreateReparationCaseData): CancelablePromise<CreateReparationCaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reparation/case',
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.limit
     * @param data.offset
     * @param data.status
     * @param data.search
     * @param data.sort
     * @param data.filters
     * @returns IReparationCasesListResponse Ok
     * @throws ApiError
     */
    public static getReparationCases(data: GetReparationCasesData): CancelablePromise<GetReparationCasesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reparation/case',
            query: {
                limit: data.limit,
                offset: data.offset,
                status: data.status,
                search: data.search,
                sort: data.sort,
                filters: data.filters
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns IGetReparationCaseDetailsResponse Ok
     * @throws ApiError
     */
    public static getReparationCase(data: GetReparationCaseData): CancelablePromise<GetReparationCaseResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reparation/case/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateReparationCase(data: UpdateReparationCaseData): CancelablePromise<UpdateReparationCaseResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/reparation/case/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createOrUpdateReview(data: CreateOrUpdateReviewData): CancelablePromise<CreateOrUpdateReviewResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reparation/case/{id}/review',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns SuccessResponse Ok
     * @throws ApiError
     */
    public static createReparationCaseItem(data: CreateReparationCaseItemData): CancelablePromise<CreateReparationCaseItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reparation/case/{id}/item',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.itemId
     * @param data.requestBody
     * @returns SuccessResponse Ok
     * @throws ApiError
     */
    public static updateReparationCaseItem(data: UpdateReparationCaseItemData): CancelablePromise<UpdateReparationCaseItemResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/reparation/case/{id}/item/{itemId}',
            path: {
                id: data.id,
                itemId: data.itemId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.itemId
     * @returns SuccessResponse Ok
     * @throws ApiError
     */
    public static deleteReparationCaseItem(data: DeleteReparationCaseItemData): CancelablePromise<DeleteReparationCaseItemResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/reparation/case/{id}/item/{itemId}',
            path: {
                id: data.id,
                itemId: data.itemId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns SuccessResponse Ok
     * @throws ApiError
     */
    public static createInvoiceFromReparationCase(data: CreateInvoiceFromReparationCaseData): CancelablePromise<CreateInvoiceFromReparationCaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reparation/case/{id}/create-invoice',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns SuccessResponse Ok
     * @throws ApiError
     */
    public static createRcPayment(data: CreateRcPaymentData): CancelablePromise<CreateRcPaymentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reparation/case/{id}/payment',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateCaseStatus(data: UpdateCaseStatusData): CancelablePromise<UpdateCaseStatusResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/reparation/case/{id}/status',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class CustomerService {
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sort
     * @param data.pagination
     * @param data.searchQuery
     * @returns ICustomerListResponse Ok
     * @throws ApiError
     */
    public static getCustomers(data: GetCustomersData): CancelablePromise<GetCustomersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer',
            query: {
                filters: data.filters,
                sort: data.sort,
                pagination: data.pagination,
                searchQuery: data.searchQuery
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns SuccessResponse Ok
     * @throws ApiError
     */
    public static createCustomer(data: CreateCustomerData): CancelablePromise<CreateCustomerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idCustomer
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateCustomer(data: UpdateCustomerData): CancelablePromise<UpdateCustomerResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/{idCustomer}',
            path: {
                idCustomer: data.idCustomer
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idCustomer
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteCustomer(data: DeleteCustomerData): CancelablePromise<DeleteCustomerResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/{idCustomer}',
            path: {
                idCustomer: data.idCustomer
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idCustomer
     * @returns ICustomer Ok
     * @throws ApiError
     */
    public static getCustomer(data: GetCustomerData): CancelablePromise<GetCustomerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/{idCustomer}',
            path: {
                idCustomer: data.idCustomer
            }
        });
    }
    
}

export class AccountingService {
    /**
     * @param data The data for the request.
     * @param data.sort
     * @param data.pagination
     * @param data.filters
     * @returns AccountListResponse Ok
     * @throws ApiError
     */
    public static getAccounts(data: GetAccountsData): CancelablePromise<GetAccountsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounting',
            query: {
                sort: data.sort,
                pagination: data.pagination,
                filters: data.filters
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sort
     * @param data.pagination
     * @param data.filters
     * @returns ChartOfAccountsResponse Ok
     * @throws ApiError
     */
    public static getChartOfAccounts(data: GetChartOfAccountsData): CancelablePromise<GetChartOfAccountsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounting/chart-of-accounts',
            query: {
                sort: data.sort,
                pagination: data.pagination,
                filters: data.filters
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sort
     * @param data.pagination
     * @param data.filters
     * @returns AccountListResponse Ok
     * @throws ApiError
     */
    public static getPaymentAccounts(data: GetPaymentAccountsData): CancelablePromise<GetPaymentAccountsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounting/payment-accounts',
            query: {
                sort: data.sort,
                pagination: data.pagination,
                filters: data.filters
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sort
     * @param data.pagination
     * @param data.filters
     * @returns AccountListResponse Ok
     * @throws ApiError
     */
    public static getExpenseAccounts(data: GetExpenseAccountsData): CancelablePromise<GetExpenseAccountsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounting/expense-accounts',
            query: {
                sort: data.sort,
                pagination: data.pagination,
                filters: data.filters
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sort
     * @param data.pagination
     * @param data.filters
     * @returns TransactionListResponse Ok
     * @throws ApiError
     */
    public static getTransactions(data: GetTransactionsData): CancelablePromise<GetTransactionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounting/transaction',
            query: {
                sort: data.sort,
                pagination: data.pagination,
                filters: data.filters
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createTransaction(data: CreateTransactionData): CancelablePromise<CreateTransactionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounting/transactions',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idTransaction
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateTransaction(data: UpdateTransactionData): CancelablePromise<UpdateTransactionResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/accounting/transactions/{idTransaction}',
            path: {
                idTransaction: data.idTransaction
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idTransaction
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteTransaction(data: DeleteTransactionData): CancelablePromise<DeleteTransactionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounting/transactions/{idTransaction}',
            path: {
                idTransaction: data.idTransaction
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sort
     * @param data.pagination
     * @param data.filters
     * @returns IGetExpenseCategoriesResponse Ok
     * @throws ApiError
     */
    public static getExpenseCategories(data: GetExpenseCategoriesData): CancelablePromise<GetExpenseCategoriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounting/expense-categories',
            query: {
                sort: data.sort,
                pagination: data.pagination,
                filters: data.filters
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createExpenseCategory(data: CreateExpenseCategoryData): CancelablePromise<CreateExpenseCategoryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounting/expense-categories',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sort
     * @param data.pagination
     * @param data.filters
     * @returns IGetExpensesResponse Ok
     * @throws ApiError
     */
    public static getExpenses(data: GetExpensesData): CancelablePromise<GetExpensesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounting/expenses',
            query: {
                sort: data.sort,
                pagination: data.pagination,
                filters: data.filters
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createExpense(data: CreateExpenseData): CancelablePromise<CreateExpenseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounting/expenses',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idExpense
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateExpense(data: UpdateExpenseData): CancelablePromise<UpdateExpenseResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/accounting/expenses/{idExpense}',
            path: {
                idExpense: data.idExpense
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idExpense
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteExpense(data: DeleteExpenseData): CancelablePromise<DeleteExpenseResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounting/expenses/{idExpense}',
            path: {
                idExpense: data.idExpense
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idExpenseCategory
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateExpenseCategory(data: UpdateExpenseCategoryData): CancelablePromise<UpdateExpenseCategoryResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/accounting/expense-category/{idExpenseCategory}',
            path: {
                idExpenseCategory: data.idExpenseCategory
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteExpenseCategory(data: DeleteExpenseCategoryData): CancelablePromise<DeleteExpenseCategoryResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounting/expense-categories/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sort
     * @param data.filters
     * @param data.pagination
     * @returns TaxListResponse Ok
     * @throws ApiError
     */
    public static getTaxes(data: GetTaxesData): CancelablePromise<GetTaxesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounting/tax',
            query: {
                sort: data.sort,
                filters: data.filters,
                pagination: data.pagination
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createTax(data: CreateTaxData): CancelablePromise<CreateTaxResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounting/tax',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idTax
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateTax(data: UpdateTaxData): CancelablePromise<UpdateTaxResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/accounting/tax/{idTax}',
            path: {
                idTax: data.idTax
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.idTax
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteTax(data: DeleteTaxData): CancelablePromise<DeleteTaxResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounting/tax/{idTax}',
            path: {
                idTax: data.idTax
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sort
     * @param data.pagination
     * @param data.filters
     * @returns IGetCurrencyListResponse Ok
     * @throws ApiError
     */
    public static getCurrencies(data: GetCurrenciesData): CancelablePromise<GetCurrenciesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounting/currencies',
            query: {
                sort: data.sort,
                pagination: data.pagination,
                filters: data.filters
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createCurrency(data: CreateCurrencyData): CancelablePromise<CreateCurrencyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounting/currencies',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateCurrency(data: UpdateCurrencyData): CancelablePromise<UpdateCurrencyResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/accounting/currencies/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sort
     * @param data.pagination
     * @param data.filters
     * @returns IGetBankAccountsResponse Ok
     * @throws ApiError
     */
    public static getBankAccounts(data: GetBankAccountsData): CancelablePromise<GetBankAccountsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounting/bank-accounts',
            query: {
                sort: data.sort,
                pagination: data.pagination,
                filters: data.filters
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createBankAccount(data: CreateBankAccountData): CancelablePromise<CreateBankAccountResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounting/bank-accounts',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns IBankAccountItem Ok
     * @throws ApiError
     */
    public static getBankAccount(data: GetBankAccountData): CancelablePromise<GetBankAccountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounting/bank-accounts/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateBankAccount(data: UpdateBankAccountData): CancelablePromise<UpdateBankAccountResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/accounting/bank-accounts/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteBankAccount(data: DeleteBankAccountData): CancelablePromise<DeleteBankAccountResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounting/bank-accounts/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static createAccount(data: CreateAccountData): CancelablePromise<CreateAccountResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounting/accounts',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.accountId
     * @param data.requestBody
     * @returns unknown Ok
     * @throws ApiError
     */
    public static updateAccount(data: UpdateAccountData): CancelablePromise<UpdateAccountResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/accounting/accounts/{accountId}',
            path: {
                accountId: data.accountId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.accountId
     * @returns unknown Ok
     * @throws ApiError
     */
    public static deleteAccount(data: DeleteAccountData): CancelablePromise<DeleteAccountResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounting/accounts/{accountId}',
            path: {
                accountId: data.accountId
            }
        });
    }
    
}